import * as React from 'react';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { getOwaCommonStrings } from 'owa-strings/owa-common-strings';
import {
    isCreatingNewFolder,
    isUserEnteringNewFolderName,
} from '../selectors/createNewFolderSelectors';
import { isLoading } from '../selectors/loadingSelectors';
import { observer } from 'mobx-react';

const styles = require('./FolderSelectorBottomPart.scss');

export interface FolderSelectorBottomPartProps {
    onPrimaryButtonClicked: () => void;
    onCancelButtonClicked: () => void;
    primaryButtonString: () => string;
}

@observer
export class FolderSelectorBottomPart extends React.Component<FolderSelectorBottomPartProps, {}> {
    render() {
        const { primaryButtonString } = this.props;
        const disablePrimaryButton =
            isLoading() || isUserEnteringNewFolderName() || isCreatingNewFolder();

        return (
            <div className={styles.container}>
                <div className={styles.buttonsContainer}>
                    <PrimaryButton
                        disabled={disablePrimaryButton}
                        className={styles.primaryButton}
                        text={primaryButtonString()}
                        onClick={this.props.onPrimaryButtonClicked}
                    />

                    <DefaultButton
                        text={getOwaCommonStrings().dismissFolderSelectorButton}
                        onClick={this.props.onCancelButtonClicked}
                    />
                </div>
            </div>
        );
    }
}
